// extracted by mini-css-extract-plugin
module.exports = {"startContractPageRoot":"startContractPageRoot--ff1fc"};